const networkHeader = document.querySelector<HTMLElement>(
	'[data-network-header]',
);
const pageHeader = document.querySelector<HTMLElement>('[data-page-header]');

let hasSetHeight = false;

const setHeaderHeight = () => {
	if (hasSetHeight || window.scrollY > 0) return;

	const networkHeaderRect = networkHeader?.getBoundingClientRect();
	const pageHeaderRect = pageHeader?.getBoundingClientRect();
	const remInPx = parseFloat(
		getComputedStyle(document.documentElement).fontSize,
	);

	const height =
		(networkHeaderRect?.height || 0) + (pageHeaderRect?.height || 0);
	const heightInRem = `${height / remInPx}rem`;

	document.documentElement.style.setProperty(
		'--full-header-height',
		heightInRem,
	);
	hasSetHeight = true;
};

window.addEventListener('resize', () => {
	hasSetHeight = false;
	setHeaderHeight();
});

window.addEventListener('scroll', () => {
	setHeaderHeight();
});

setHeaderHeight();
